/**
 * Product Image Zoom
 * Desktop: hover scales the image, cursor position controls transform-origin
 * Mobile: tap opens fullscreen lightbox with high-res image
 */
(function () {
  const ZOOM_SCALE = 2;
  let lightbox = null;

  function init() {
    const galleryMain = document.querySelector('.gallery-main');
    if (!galleryMain) return;

    const isTouch = matchMedia('(hover: none), (pointer: coarse)').matches;

    if (!isTouch) {
      setupDesktopZoom(galleryMain);
    }
    // Mobile lightbox for both - tap on image opens full-res
    setupMobileLightbox(galleryMain);
  }

  /* ── Desktop: hover zoom via transform ── */
  function setupDesktopZoom(container) {
    container.classList.add('pz-hover-zoom');

    container.addEventListener('mousemove', function (e) {
      const img = container.querySelector('.gallery-main-img.active');
      if (!img) return;

      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = x + '% ' + y + '%';
    });

    container.addEventListener('mouseenter', function () {
      var img = container.querySelector('.gallery-main-img.active');
      if (img) img.classList.add('pz-zoomed');
    });

    container.addEventListener('mouseleave', function () {
      var img = container.querySelector('.gallery-main-img.active');
      if (img) {
        img.classList.remove('pz-zoomed');
        img.style.transformOrigin = '';
      }
    });
  }

  /* ── Mobile: tap to open lightbox ── */
  function setupMobileLightbox(container) {
    container.addEventListener('click', function (e) {
      // Only on touch devices
      if (!matchMedia('(hover: none), (pointer: coarse)').matches) return;
      if (e.target.closest('.gallery-thumbnail, .gallery-nav')) return;

      var img = container.querySelector('.gallery-main-img.active');
      if (!img) return;

      var src = img.dataset.zoom || img.dataset.src || img.src;
      openLightbox(src, img.alt);
    });
  }

  function openLightbox(src, alt) {
    if (lightbox) lightbox.remove();

    lightbox = document.createElement('div');
    lightbox.className = 'pz-lightbox';
    lightbox.innerHTML =
      '<button class="pz-lightbox__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<path d="M18 6L6 18M6 6l12 12"/>' +
        '</svg>' +
      '</button>' +
      '<div class="pz-lightbox__scroll">' +
        '<img class="pz-lightbox__img" src="' + src + '" alt="' + (alt || '') + '">' +
      '</div>';

    document.body.appendChild(lightbox);
    document.body.style.overflow = 'hidden';

    // Animate in
    requestAnimationFrame(function () {
      lightbox.classList.add('pz-lightbox--open');
    });

    lightbox.querySelector('.pz-lightbox__close').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('pz-lightbox__scroll')) {
        closeLightbox();
      }
    });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('pz-lightbox--open');
    setTimeout(function () {
      if (lightbox) lightbox.remove();
      lightbox = null;
      document.body.style.overflow = '';
    }, 200);
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
